'use client';

import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faSliders } from '@fortawesome/pro-solid-svg-icons';
import useFilterSets from 'src/hooks/filters/useFilterSets';
import { useDrawer } from 'src/hooks/drawers/useDrawer';
import useIsAdvancedSearchActive from 'src/hooks/discovery/useIsAdvancedSearchActive';
import { LOCATION } from 'src/hooks/filters/constants';

interface ResultsFilterButtonProps {
  count?: number;
  onClick?: () => void;
}

const ResultsFilterButton: React.FC<ResultsFilterButtonProps> = ({
  onClick,
}) => {
  const { getTotalFilterCount } = useFilterSets(LOCATION.DISCOVERY);
  const { closeAllButCurrent } = useDrawer();
  const isAdvancedSearchActive = useIsAdvancedSearchActive();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      closeAllButCurrent('allFiltersDrawer');
    }
  };

  if (isAdvancedSearchActive) return null;

  const count = getTotalFilterCount();
  return (
    <button
      type="button"
      className="h-8 px-3.5 bg-white rounded-full outline outline-[0.83px] outline-offset-[-0.83px] outline-neutral-300 inline-flex justify-center items-center gap-2 hover:bg-neutral-50"
      onClick={handleClick}
      aria-label="Filter results"
      data-testid="results-filter-button"
    >
      <div className="w-3.5 h-3.5 flex items-center justify-center">
        <Icon icon={faSliders} className="w-3 h-3 text-neutral-600" />
      </div>
      <span className="text-neutral-600 text-sm font-medium font-['Inter'] leading-tight">
        Filter
      </span>
      <div
        className="bg-sky-100 flex justify-center items-center"
        style={{
          width: '17px',
          height: '22px',
          gap: '4px',
          opacity: 1,
          borderRadius: '99px',
          padding: '4px',
        }}
      >
        <div className="text-center text-neutral-700 text-xs font-bold font-['Inter'] leading-none">
          {count}
        </div>
      </div>
    </button>
  );
};

export default ResultsFilterButton;
